import * as React from "react";
const SvgFiRrC = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M13 24h-1C6.486 24 2 19.514 2 14v-4C2 4.486 6.486 0 12 0h1a9.95 9.95 0 0 1 8.96 5.554 1 1 0 0 1-1.791.891A7.96 7.96 0 0 0 13 2h-1c-4.411 0-8 3.589-8 8v4c0 4.411 3.589 8 8 8h1c3.006 0 5.73-1.66 7.111-4.333a1 1 0 1 1 1.778.918A9.97 9.97 0 0 1 13 24"
    />
  </svg>
);
export default SvgFiRrC;
